
import Box  from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import React from 'react'
import Header from './Header'

const Layout: React.FC<{
    children: any
}> = ({children}) => {
    return (
        <div className="layout">
        <Header />
        <Box className="content" sx={{
            marginTop: '64px',
            minHeight: '90vh',
            marginLeft: {
                md: '200px',
                sm: 0
            }
        }}>
          {children}
          </Box>
          <footer>
        <Typography align="center">&copy; RelicInnova 2021 </Typography>
      </footer>
      </div>
    )
}

export default Layout
